import LegalPage from "@/components/LegalPage";

const DEFAULT_BODY = (
  <>
    <p className="text-oc-textSecondary"><em>OfferteExpert — Webtron BV</em></p>

    <h2>Wat zijn cookies?</h2>
    <p>Cookies zijn kleine tekstbestanden die worden opgeslagen op je toestel wanneer je een website bezoekt. Ze laten toe om voorkeuren te onthouden en het gebruik van de site te analyseren.</p>

    <h2>Welke cookies gebruiken we?</h2>
    <ul>
      <li><strong>Noodzakelijke cookies</strong> — voor sessiebeheer, beveiliging en cookie-consent. Altijd actief.</li>
      <li><strong>Analytische cookies</strong> — Google Analytics 4 (anoniem, geaggregeerd). Optioneel.</li>
      <li><strong>Marketing cookies</strong> — Facebook Pixel, Google Ads, TikTok, LinkedIn. Pas actief na expliciete toestemming via de cookiebanner.</li>
    </ul>

    <h2>Cookies beheren</h2>
    <p>Je kan op elk moment je voorkeuren wijzigen via de "Cookie-instellingen aanpassen" link in de footer of via de instellingen van je browser.</p>

    <h2>Bewaartermijn</h2>
    <p>Sessiecookies worden verwijderd zodra je de browser sluit. Persistente cookies blijven maximaal 12 maanden.</p>

    <h2>Contact</h2>
    <p>Voor vragen over ons cookiebeleid: <a href="mailto:info@offerteexpert.be">info@offerteexpert.be</a>.</p>
  </>
);

export default function Cookiebeleid() {
  return <LegalPage slug="cookies" defaultTitle="Cookiebeleid" defaultBody={DEFAULT_BODY} />;
}
